// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file Sectorization.proto (package Sectorization, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file Sectorization.proto.
 */
export const file_Sectorization: GenFile = /*@__PURE__*/
  fileDesc("ChNTZWN0b3JpemF0aW9uLnByb3RvEg1TZWN0b3JpemF0aW9uItcDCg1TZWN0b3JpemF0aW9uEi4KCmlzc2VsZWN0ZWQYASABKAsyGi5nb29nbGUucHJvdG9idWYuQm9vbFZhbHVlEicKAmlkGAIgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSGwoTbm9ybWFsU2VjdG9yaXphdGlvbhgDIAEoCBIyCg1kb2NMb3dlckxpbWl0GAQgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkZsb2F0VmFsdWUSKQoDZG9jGAUgASgLMhwuZ29vZ2xlLnByb3RvYnVmLkRvdWJsZVZhbHVlEjEKC21heGFsdGl0dWRlGAYgASgLMhwuZ29vZ2xlLnByb3RvYnVmLkRvdWJsZVZhbHVlEi0KCG1heGFuZ2xlGAcgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSMQoLbWluYWx0aXR1ZGUYCCABKAsyHC5nb29nbGUucHJvdG9idWYuRG91YmxlVmFsdWUSLQoIbWluYW5nbGUYCSABKAsyGy5nb29nbGUucHJvdG9idWYuSW50MzJWYWx1ZRItCghuYXZhaWRQaxgKIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlQkMKLWNvbS5nbXYuZGVtZXRlci5uYXZhaWRzLm1vZGVsLnByb3RvLmdlbmVyYXRlZEISU2VjdG9yaXphdGlvblByb3RvYgZwcm90bzM", [file_google_protobuf_wrappers]);

/**
 * @generated from message Sectorization.Sectorization
 */
export type Sectorization = Message<"Sectorization.Sectorization"> & {
  /**
   * @generated from field: google.protobuf.BoolValue isselected = 1;
   */
  isselected?: boolean;

  /**
   * @generated from field: google.protobuf.Int32Value id = 2;
   */
  id?: number;

  /**
   * @generated from field: bool normalSectorization = 3;
   */
  normalSectorization: boolean;

  /**
   * @generated from field: google.protobuf.FloatValue docLowerLimit = 4;
   */
  docLowerLimit?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue doc = 5;
   */
  doc?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue maxaltitude = 6;
   */
  maxaltitude?: number;

  /**
   * @generated from field: google.protobuf.Int32Value maxangle = 7;
   */
  maxangle?: number;

  /**
   * @generated from field: google.protobuf.DoubleValue minaltitude = 8;
   */
  minaltitude?: number;

  /**
   * @generated from field: google.protobuf.Int32Value minangle = 9;
   */
  minangle?: number;

  /**
   * @generated from field: google.protobuf.Int32Value navaidPk = 10;
   */
  navaidPk?: number;
};

/**
 * Describes the message Sectorization.Sectorization.
 * Use `create(SectorizationSchema)` to create a new message.
 */
export const SectorizationSchema: GenMessage<Sectorization> = /*@__PURE__*/
  messageDesc(file_Sectorization, 0);

